import { Font } from '@danone-global/internal/react/core'

import boldWoff from '../../../../../fonts/VAGRoundedPROBold.woff'
import boldWoff2 from '../../../../../fonts/VAGRoundedPROBold.woff2'
import lightWoff from '../../../../../fonts/VAGRoundedPROLight.woff'
import lightWoff2 from '../../../../../fonts/VAGRoundedPROLight.woff2'
import mediumWoff from '../../../../../fonts/VAGRoundedPRONormal.woff'
import mediumWoff2 from '../../../../../fonts/VAGRoundedPRONormal.woff2'

export const fonts: Font[] = [
  {
    fontFamily: 'cg-font',
    fontWeight: 300,
    fontStyle: 'normal',
    woff: lightWoff,
    woff2: lightWoff2,
  },
  {
    fontFamily: 'cg-font',
    fontWeight: 400,
    fontStyle: 'normal',
    woff: mediumWoff,
    woff2: mediumWoff2,
  },
  {
    fontFamily: 'cg-font',
    fontWeight: 700,
    fontStyle: 'normal',
    woff: boldWoff,
    woff2: boldWoff2,
  },
]
